import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import pageTitleProps from "@store/theme/props/pageTitle";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import * as React from "react";
import { css } from "styled-components";

const PageTitle = getWidgetComponent("Basic/PageTitle");
const SavedPaymentsAddCardButton = getWidgetComponent("SavedPayments/SavedPaymentsAddCardButton");

type Props = WidgetProps;

export interface SavedPaymentsHeaderStyles {
    wrapper?: TypographyPresentationProps;
    innerWrapper?: TypographyPresentationProps;
    titleWrapper?: InjectableCss;
    actionWrapper?: InjectableCss;
}

export const headerStyles: SavedPaymentsHeaderStyles = {
    wrapper: {
        ...pageTitleProps,
        forwardAs: "div",
    },
    innerWrapper: {
        variant: "body",
        forwardAs: "div",
        css: css`
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;
            align-items: center;
            margin: -0.5em 0 0 -1em;
        `,
    },
    titleWrapper: {
        css: css`
            flex: 99 1 auto;
            margin: 0.5em 0 0 1em;
        `,
    },
    actionWrapper: {
        css: css`
            flex: 1 1 auto;
            margin: 0.5em 0 0 1em;
        `,
    },
};

const styles = headerStyles;

const SavedPaymentsHeader: React.FC<Props> = () => {
    return (
        <Typography {...styles.wrapper}>
            <Typography {...styles.innerWrapper}>
                <StyledWrapper {...styles.titleWrapper}>
                    <PageTitle />
                </StyledWrapper>
                <StyledWrapper {...styles.actionWrapper}>
                    <SavedPaymentsAddCardButton />
                </StyledWrapper>
            </Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: SavedPaymentsHeader,
    definition: {
        group: "Saved Payments",
        displayName: "Page Header",
        allowedContexts: ["SavedPaymentsPage"],
    },
};

export default widgetModule;
